export default function() {
  /* ---------------------------------------------------- */
  /*  TABLE Style mobile
  /* ---------------------------------------------------- */

  let headertext = [];
  const headers = document.querySelectorAll( 'thead' );
  const tablebody = document.querySelectorAll( 'tbody' );
  let current = undefined;
  let tbody = undefined;

  for ( let i = 0; i < headers.length; i++ ) {
    headertext[i] = [];
    for ( let j = 0; j < headers[i].rows[0].cells.length; j++ ) {
      current = headers[i].rows[0].cells[j];
      headertext[i].push( current.textContent.replace( /\r?\n|\r/, '' ) );
    }
  }
  if ( headers.length > 0 ) {
    for ( let h = 0; h < tablebody.length; h++ ) {
      tbody = tablebody[h];
      for ( let row of tbody.rows ) {
        for ( let j = 0; j < row.cells.length; j++ ) {
          if ( headertext[h] !== undefined ) {
            row.cells[j].setAttribute( 'data-th', headertext[h][j] );
          }
        }
      }
    }
  }
}
